"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _FunnelSelectCardGrid = _interopRequireDefault(require("./FunnelSelectCardGrid"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = _FunnelSelectCardGrid.default;
exports.default = _default;